import { defineStore } from 'pinia'

import type { AuthStore } from './interfaces'

import {
  AuthDisplay,
  AuthMethod,
} from '@brighterly/lib-core-types/login/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useAuthStore = defineStore('auth', {
  state: (): AuthStore => ({
    loading: false,
    authMethod: AuthMethod.Phone,
    authDisplay: AuthDisplay.Login,
    otpCode: '',
    otpError: false,
    otpReSend: false,
    phone: '',
    phoneValid: false,
    email: '',
    emailValid: false,
    notification: {
      show: false,
      title: '',
      description: '',
      mode: 'info',
    },
    accessToken: '',
    refreshToken: '',
    tokenType: 'Bearer',
    expiresAt: 0,
    refreshing: null,
  }),
  actions,
  getters,
})
